var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { POSITION_EMPTY_VALIDATION, POSITION_ERROR, POSITION_ERROR_HIDE, POSITION_HIDE_EMPTY_VALIDATION, POSITION_REPORT, } from "@redux/interfaces/Reports/iPositionReport";
var initState = {
    data: {
        PositionData: {
            PositionSummary: {
                date: "",
                time: "",
                totalPnL: null,
                totalPnLPercent: "",
                realizedPnL: null,
                realizedPnLPercent: "",
                unRealizedMTM: null,
                unRealizedMTMPercent: "",
                daysMTM: null,
                daysMTMPercent: "",
                totalPosition: "",
                openPosition: "",
                closedPosition: "",
                positiveTotalPNLCount: 0,
                negativeTotalPNLCount: 0,
            },
            PositionDetailsClosed: [],
            PositionDetailsOpen: [],
            positionsCombined: new Map(),
        },
    },
    errorData: {
        error: null,
        isOpen: false,
    },
    squareOffStatus: {
        error: null,
        isOpen: null,
    },
    emptyValidation: {
        icon: null,
        message: null,
    },
};
var positionReport = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case POSITION_REPORT:
            return __assign(__assign({}, state), { data: action.payload.data });
        case POSITION_ERROR:
            return __assign(__assign({}, state), (_a = {}, _a[action.errorType] = action.payload.errorData, _a));
        case POSITION_ERROR_HIDE:
            return __assign(__assign({}, state), (_b = {}, _b[action.errorType] = initState[action.errorType], _b));
        case POSITION_EMPTY_VALIDATION:
            return __assign(__assign({}, state), { emptyValidation: action.payload.emptyValidation });
        case POSITION_HIDE_EMPTY_VALIDATION:
            return __assign(__assign({}, state), { emptyValidation: initState.emptyValidation });
        default:
            return __assign({}, state);
    }
};
export default positionReport;
